export function addDessinnr(array) {
  const lNumber = document.getElementById("l-no");
  lNumber.value = array["dessinnr"];
  document.getElementById("project-name").textContent = array["dessinnr"];
  if ("paarnr" in array) {
    const rNumber = document.getElementById("r-no");
    rNumber.value = array["paarnr"];
  }
}
